import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Fieldset} from "primereact/fieldset";
import React, {useContext, useEffect, useState} from "react";
import {Panel} from "primereact/panel";
import {AuthContext} from "../App";
import {MainPageContext} from "./MainPage";
import {SongService} from "../services/SongService";
import {getShuffled, groupSongsByISRC, setRowNrToPlaylist} from "../utils/PlaylistHelper";
import SongDistributionChart from "./SongDistributionChart";
import SongTitleDistributionChart from "./SongTitleDistributionChart";
import SongSelector from "./SongSelector";
import {SplitButton} from "primereact/splitbutton";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {PlaylistSaveToStreamingService} from "./PlaylistSaveToStreamingService";
import {PlaylistChecker} from "./PlaylistChecker";
import PlaylistEditorInfo from "./PlaylistEditorInfo";


// should it be implicitely connected to the Generator?
export function PlaylistManipulator({initPlaylist, spotifyUsers, incrementPlaylistCounter}) {
    // general things
    const auth = useContext(AuthContext);
    const mp = useContext(MainPageContext);
    const songservice = new SongService();
    const [playlistURL, setPlaylistURL] = useState(null);


    // the playlist to be edited
    const [spotifyInitializerPlaylist, setSpotifyInitializerPlaylist] = useState('');
    //const [playlistVersion, setPlaylistVersion] = useState(null); // spotify snapshot_id, applemusic versionHash
    const [playlist, setPlaylist] = useState([]);
    const [editInfo, setEditInfo] = useState({editable: false, spotifyplaylist_id: "undefined", spotifyuser_id: -1, plname:"", pldescription:""});
    const [buttonsDisabled, setButtonsDisabled] = useState(false);
    const [selectedPlaylistRow, setSelectedPlaylistRow] = useState(null); // for highlighting the selected Song

    const [songs, setSongs] = useState([]);
    const [songSelectionVisible, setSongSelectionVisible] = useState('');
    const [nrReps, setNrReps] = useState(null);

    // actions on the playlist
    const [songToBeReplaced, setSongToBeReplaced] = useState(null);
    const [replaceAll, setReplaceAll] = useState(false);
    const [addMethod, setAddMethod] = useState(null);
    const [currElementId, setCurrElementId] = useState(0);


    useEffect(() => {
        songservice.getSongs().then(data => setSongs(data));
        if(initPlaylist && spotifyInitializerPlaylist ==='') {
            setSpotifyInitializerPlaylist(initPlaylist);
            loadPlaylistFromSpotify(initPlaylist);
        }
    }, []);

    function updatePlaylistState(pl){
        // this was necessary to force a full reload of the playlist after deleting items...
        // often an old state was used, and things got messy.
        // Not sure if this is THE correct solution or if there is a better option!
        let _playlist = setRowNrToPlaylist(pl, currElementId);
        let _currElementId = currElementId + _playlist.length;
        setCurrElementId(_currElementId);
        setPlaylist(_playlist);
    }

    const loadPlaylistFromSpotify = (spotifyplaylistid) => {
        songservice.loadPlaylist(spotifyplaylistid, auth.getAccessToken()).then(data => {
            if(data["detail"]) {
                mp.mainToast.current.show({
                    severity:'error',
                    summary: 'Playlist Not Found',
                    detail: 'Spotify: playlist link or ID. Apple Music: ID starting with pl. or catalog link (via playlist share), the library link will not work.',
                    life: 6000})
            } else {
                updatePlaylistState(data["playlist"]);
                setPlaylistURL("");
                //setPlaylistVersion(data["version"]);
                setEditInfo(data.edit_info);
                let _removed_tracks = data["removed_tracks"];
                if (_removed_tracks.length > 0) {
                    mp.mainToast.current.show({
                        severity: 'warn',
                        summary: (_removed_tracks.length + " tracks were not supported and dropped"),
                        detail: 'e.g. ' + _removed_tracks[0]["main_artist"] + " - " + _removed_tracks[0]["title"],
                        life: 6000
                    })
                }
            }
        });
    }

    function getRandomFloatBetween(min, max) {
        return min + Math.random() * (max - min);
    }

    const addSelectedSong = (selectedSong)=> {
        // this is called when pressing the button ... this should not happen ... can I avoid it?
        let _playlist = [...playlist];
        let _song = { ...selectedSong }
        if(addMethod === 'atend'){
            _playlist.push(_song);
        } else if (addMethod === 'atbeginning') {
            _playlist = [_song, ...playlist];
        } else if (addMethod === 'spread') {
            let isrc = _song.isrc;
            let songAlternatives = songs.filter((song) => {return song.isrc === _song.isrc})
            let occurences = groupSongsByISRC(_playlist);
            let _plFiltered = _playlist.filter((song) => {return song.isrc !== _song.isrc});

            if(_plFiltered.length < 5) {
                // 4 songs ...
                // add 3: A**A**A
                // add 2: A**A**, A***A*, A****A, *A***A, **A**A, *A**A*
                // add 1: A****,*A***,**A**,***A*,****A
                // 3,
                // add 2 songs: A***A A**A* *A**A,
                // add 1 A*** *A** **A* ***A
                // 2
                // add 2 A**A
                // add 1 A** *A* **A

            } else {
                let _newOcc =  nrReps;
                if(isrc in occurences){_newOcc = _newOcc + occurences[isrc];}
                let medianDelta = Math.floor((_plFiltered.length-4)/(_newOcc - 1)); // -4 to account for end and start

                let start = Math.ceil(Math.random()*3) - 1; // 0,1,2
                let end = Math.ceil(Math.random()*3) - 1; // 0,1,2

                let remainder = _plFiltered.length - start - end;
                let remNrSongs = _newOcc - 2


                let deltaoptions = [2,3,4] // that is the minimum! change if median > 3
                let deltaweights = [0.6, 0.3, 0.1] // insert randomisation ? 0.5- 0.7, 0.2-0.3, remainder
                if(medianDelta > 3){
                    deltaoptions = [medianDelta-1, medianDelta, medianDelta+1];
                    if(medianDelta  < 6 ){
                        // 4 or 5
                        deltaweights = [0.2, 0.6, 0.2]
                    } else {
                        deltaweights = [0.3, 0.4, 0.3]
                    }
                }

                let deltas = [];
                if(remNrSongs > 0){
                // assign the 2 longest first
                    for(let i = 1; i < deltaweights.length; i++){
                        let _deltas = new Array(Math.floor(remNrSongs*deltaweights[i]))
                        _deltas.fill(deltaoptions[i])
                        deltas.push(..._deltas)
                    }
                    // assign all missing deltas the shortest deltaoption
                    let _deltas = new Array(remNrSongs - (deltas.length - 1));
                    _deltas.fill(deltaoptions[0]);
                    deltas.push(..._deltas);

                    // handle unassigned
                    let unassignedSlots = _plFiltered.length - deltas.reduce((a,b) => a + b, 0) - start - end;
                    if(unassignedSlots > 0){
                        //perfect, assign the remaining playlistsongs
                        deltas = getShuffled(deltas);
                        for(let j= 0; j<unassignedSlots;j++){
                            if(j >= deltas.length){
                                let k = j%deltas.length
                                deltas[k] = deltas[k] + 1;
                            } else {
                                deltas[j] = deltas[j] + 1;
                            }
                        }
                        deltas = getShuffled(deltas);
                    } else if (unassignedSlots === 0){
                        // great nothing to do
                    } else {
                        // remove deltas
                        let cntRemovals = 0;
                        let cntRemovedSlots = 0;
                        let overbookedSlots = -unassignedSlots;
                        // deltas.reverse(); // remove from the end ... there were almost no 2 slots... also not optimal, now it is almost all 2 slots
                        for(let i = 0; i < deltas.length; i++){
                            if(cntRemovedSlots < overbookedSlots){
                                cntRemovedSlots = cntRemovedSlots + deltas[i];
                                cntRemovals = cntRemovals + 1;
                            } else {
                                break;
                            }
                        }
                        deltas = deltas.slice(cntRemovals, deltas.length);
                        // fix it and then shuffle it
                        deltas[0] = deltas[0]+(cntRemovedSlots - overbookedSlots);
                        deltas = getShuffled(deltas);

                        // slots are missing, we have to delete some to
                        mp.mainToast.current.show({severity:"info", summary:"Could not add the song " + nrReps + " times. Added it as much as possible ("+(_newOcc - cntRemovals)+"), ensuring minimal and varied spacing"})
                    }
                } else if (_newOcc == 1) {
                    start = floor(_playlist.length/2);
                    end = _playlist.length-start;
                } else if (_newOcc == 2) {
                    if(_playlist.length <7){
                        if(start === end && start === 2){
                            start = 0;
                        }
                        deltas.push(_playlist.length - start - end)
                    } else {
                        let middle = Math.floor(_playlist.length / 3);
                        start = middle -1 + Math.ceil(Math.random()*3); // middle-1, middle, middle +1
                        end = middle -1 + Math.ceil(Math.random()*3); // middle-1, middle, middle +1
                        deltas.push(_playlist.length - start - end)
                    }
                }
                // build the new playlist
                let _songAlternatives = getShuffled(songAlternatives);
                let newPlaylist = _plFiltered.slice(0, start);
                newPlaylist.push({..._songAlternatives[0]})
                _songAlternatives = _songAlternatives.slice(1);

                let lastindex = start;
                for(let i = 0; i < deltas.length; i++){
                    if(_songAlternatives.length === 0) {_songAlternatives = getShuffled(songAlternatives);}
                    let nextindex = lastindex + deltas[i];
                    newPlaylist.push(..._plFiltered.slice(lastindex, nextindex))
                    newPlaylist.push({..._songAlternatives[0]});
                    _songAlternatives = _songAlternatives.slice(1);
                    lastindex = nextindex;
                }
                newPlaylist.push(..._plFiltered.slice(lastindex, _plFiltered.length))
                _playlist = newPlaylist;
            }
        } else {
            mp.mainToast.current.show({severity: 'warn', summary: 'Unexpected method ' + addMethod +', not implemented', life: 6000})
        }
        setNrReps(null);
        updatePlaylistState(_playlist);
        setSongSelectionVisible('');
    }

    function deleteSelectedSong(rowData, all=false) {
        let _song = {...rowData}
        let _playlist =[...playlist];
        if(all){
            let isrc = _song.isrc;
            _playlist = _playlist.filter(song => {return song.isrc !== isrc})
        } else {
            let plelementid = _song.plelementid; // this is just the original or later changed one, no guarantee of position!
            _playlist = _playlist.filter(song => {return song.plelementid !== plelementid})
        }
        updatePlaylistState(_playlist);
        //mp.mainToast.current.show({severity: "info", summary: "Delete selected song "+_song.plelementid + " isrc: " + _song.isrc});
    }



    function replaceSelectedSong(selectedSong) {
        let _playlist = [];
        if(replaceAll){
            let isrc = songToBeReplaced.isrc;
            let songAlternatives = songs.filter((song) => {return song.isrc === selectedSong.isrc})

            let _songAlternatives = []
            for(let i=0; i<playlist.length; i++){
                if(_songAlternatives.length === 0) {_songAlternatives = getShuffled(songAlternatives);}
                if(playlist[i].isrc === isrc){
                    _playlist.push({..._songAlternatives[0]});
                    _songAlternatives = _songAlternatives.slice(1);
                } else {
                    _playlist.push({...playlist[i]});
                }
            }
        } else {
            let plelementid = songToBeReplaced.plelementid;
            for(let i=0; i<playlist.length; i++){
                if(playlist[i].plelementid !== plelementid){
                    _playlist.push({...playlist[i]});
                } else {
                    _playlist.push({...selectedSong});
                }
            }
        }
        //mp.mainToast.current.show({severity: "info", summary: "TODO: replace selected song " +songToBeReplaced.plelementid + " isrc: " + songToBeReplaced.isrc});
        setSongToBeReplaced(null);
        setReplaceAll(false);
        setSongSelectionVisible('');
        updatePlaylistState(_playlist);
    }

    function openSongSelection(rowData, all=false) {
        setReplaceAll(all);
        setSongToBeReplaced(rowData);
        setSongSelectionVisible('replaceSelector');
    }

    const textDialogEntry = () => {
        return (<div>Select song to be added</div>)
    }

    const deleteButtonItems = (rowData) => {
        let items = [];
        items.push(
            {
                label: 'Delete all',
                icon: 'pi pi-trash',
                command: (e) => {
                    deleteSelectedSong(rowData,true);
                }
            }
        );
        return(items);
    }

    const replaceButtonItems= (rowData) =>{
        return([
            {
                label: 'Replace all',
                icon: 'pi pi-arrow-right-arrow-left',
                command: (e) => {
                    openSongSelection(rowData, true);
                }
            }]);
    }

    function splitButtonItems() {
        let items = [];
        items.push({
            label: 'Add to beginning',
            icon: 'pi pi-plus',
            command: (e) => {
                setNrReps(null);
                setAddMethod('atbeginning');
                setSongSelectionVisible('addSelector');
            }
        })
        if(playlist.length > 4){
            items.push({
                label: 'Add many (min spacing 2, some randomness)',
                icon: 'pi pi-plus',
                command: (e) => {
                    setNrReps(1);
                    setAddMethod('spread');
                    setSongSelectionVisible('addSelector');
                }
            })
        }
        return items;
    }

    const imageTemplate = (item) => {
        return (
            <div><img src={item.image_url} width="24"/></div>
        );
    }

    const actionBodyTemplate = (rowData) => {
        // <Column body={actionBodyTemplate} exportable={false}></Column>
        return (
            <React.Fragment>
                <div className={"flex gap-2"}>
                    <SplitButton icon="pi pi-arrow-right-arrow-left" className="p-button-rounded" onClick={() => openSongSelection(rowData)} model={replaceButtonItems(rowData)}/>
                    <SplitButton icon="pi pi-trash" className="p-button-rounded" onClick={() => {deleteSelectedSong(rowData, false);}} model={deleteButtonItems(rowData)}/>
                </div>
            </React.Fragment>
        );
    }

    const songToBeReplacedDialogEntry = () => {
        if (songToBeReplaced !== null) {
            return(<div>
                    <div className={"flex flex-wrap gap-3"}>
                        <div><img src={songToBeReplaced.image_url} width="16" height="16"/></div>
                        <div>{songToBeReplaced.nameconcat}</div>
                    </div>
            </div>)
        } else {
            return(<div className={"flex flex-wrap gap-3 mt-2"}>No song selected to be replaced.</div>)
        }
    }


    function getOnSaved(url) {
        setPlaylistURL(url);
        incrementPlaylistCounter();
        setButtonsDisabled(true);
    }

    return(
        <div>
            <PlaylistEditorInfo/>
            <Panel header={"Playlist Editor"}>
                <Fieldset className={"p-0"} legend={"Load Existing Playlist"}>
                    <div className="p-0">
                        Load your playlist using the Spotify or Apple Music sharing link. Only BTS and members songs are loaded.
                    </div>
                    <div className="flex flex-wrap gap-1 pt-2">
                        <InputText className={""} value={spotifyInitializerPlaylist}
                                   onChange={(e) => setSpotifyInitializerPlaylist(e.target.value)}
                                   placeholder={"Spotify/Apple Music playlist link or id"}
                                   style={{width: '290px'}}/>
                        <Button label={"Load Playlist"} onClick={() =>
                            loadPlaylistFromSpotify(spotifyInitializerPlaylist)} disabled={(spotifyInitializerPlaylist === '')}/>
                    </div>
                </Fieldset>
                <Fieldset className={"p-0"} legend={"Playlist Description"}>
                    <div className="p-0">
                        <PlaylistChecker playlist={playlist}/>

                        <div className="flex flex-wrap gap-1 pt-2">
                            <div style={{width:'400px'}}>
                                <SongDistributionChart playlist={playlist}/>
                            </div>
                            <div style={{width:'400px'}}>
                            <SongTitleDistributionChart playlist={playlist}/>
                            </div>
                        </div>
                    </div>
                </Fieldset>
                <Fieldset className={"p-0"} legend={"Playlist"}>
                    <div className={"flex-wra gap-2"} hidden ={playlistURL === null}>
                        <a href={playlistURL}>{playlistURL}</a>
                        <Button visible={playlistURL !== null && playlistURL !== ''} size={"small"} icon="pi pi-external-link"
                                label={"Open Playlist in new Tab"} text aria-label="OpenPlaylistNewTab" onClick={() => {
                            let win = window.open(playlistURL, '_blank');
                            win.focus();
                        }}/>
                    </div>

                    <PlaylistSaveToStreamingService spotifyUsers={spotifyUsers} playlist={playlist}
                                                    onSaved={getOnSaved}
                                                    buttonsDisabled={buttonsDisabled} setButtonsDisabled={setButtonsDisabled}
                                                    editInfo = {editInfo} setEditInfo={setEditInfo} />

                    <div className="card-controls" hidden={playlist.length === 0}>
                        <div>
                            <DataTable value={playlist} dataKey='plelementid' key={'plelementid'}
                                       selectionMode="single" selection={selectedPlaylistRow}
                                       onSelectionChange={(e) => setSelectedPlaylistRow(e.value)}
                                       rowClassName={(data, options) => {if(selectedPlaylistRow !== null && data.isrc === selectedPlaylistRow.isrc){return("bg-highlight")}else{return("")}}}
                                       reorderableRows
                                       onRowReorder={(e) => setPlaylist(e.value)}>
                                <Column rowReorder style={{width: '1em'}} />
                                <Column header="Pos" headerTooltip="Playlist position" headerStyle={{ width: '1em' }} body={(data, options) => options.rowIndex + 1}></Column>
                                <Column field="image_url" header="" body={imageTemplate}></Column>
                                <Column field="nameconcat" header="Artist - Song"></Column>
                                <Column body={actionBodyTemplate} exportable={false} ></Column>
                            </DataTable>
                        </div>
                    </div>

                    <div className="p-0 mt-2">
                        <SplitButton disabled={false} icon={"pi pi-plus"} label={"Add Song"} model={splitButtonItems()}
                                onClick={ () => {
                                    setAddMethod('atend');
                                    setNrReps(null);
                                    setSongSelectionVisible('addSelector');}
                        }/>
                    </div>

                    <div className={"flex-wra gap-2"} hidden ={playlistURL === null}>
                        <a href={playlistURL}>{playlistURL}</a>
                        <Button visible={playlistURL !== null && playlistURL !== ''} size={"small"} icon="pi pi-external-link"
                                label={"Open Playlist in new Tab"} text aria-label="OpenPlaylistNewTab" onClick={() => {
                            let win = window.open(playlistURL, '_blank');
                            win.focus();
                        }}/>
                    </div>
                    <PlaylistSaveToStreamingService spotifyUsers={spotifyUsers} playlist={playlist}
                                                    onSaved={getOnSaved}
                                                    buttonsDisabled={buttonsDisabled} setButtonsDisabled={setButtonsDisabled}
                                                    editInfo = {editInfo} setEditInfo={setEditInfo} />

                    <div>
                        <SongSelector songs={songs}  header="Add" visible={songSelectionVisible === 'addSelector'} setVisible={
                            (vis) => {
                                if(vis){setSongSelectionVisible('addSelector')}
                                else {setSongSelectionVisible('')}
                            }}
                                      onSelectionConfirmed={addSelectedSong} dialogText={textDialogEntry()}
                                      selectedNrReps={nrReps} setSelectedNrReps={setNrReps} minNrReps={2}
                        />
                        <SongSelector songs={songs} header={replaceAll ? "Replace All" : "Replace"} visible={songSelectionVisible === 'replaceSelector'} setVisible={
                            (vis) => {
                                if(vis){setSongSelectionVisible('replaceSelector')}
                                else {setSongSelectionVisible('')}
                            }}
                                      onSelectionConfirmed={replaceSelectedSong} dialogText={songToBeReplacedDialogEntry()}
                                      selectedNrReps={null} setSelectedNrReps={null}
                        />
                    </div>

                </Fieldset>
            </Panel>
        </div>
    )
}